import update from 'immutability-helper';
import { set, findIndex, reject, flow, merge } from 'lodash/fp';
import { EDITOR } from 'constants/actionTypes';
import {
  removeAndUpdatePositions,
  sortAndUpdatePositions,
  resetPositions,
  updateItem,
} from 'utils/fp';

const reduceElements = (elements = [], action) => {
  switch (action.type) {
    case EDITOR.ELEMENT.DELETE:
      return removeAndUpdatePositions(action.id)(elements);

    case EDITOR.ELEMENT.DELETE_CHILDREN: {
      return flow(reject({ parent_id: action.id }), resetPositions)(elements);
    }

    case EDITOR.ELEMENT.SET_VALIDITY: {
      const { valid, id } = action;
      const index = findIndex({ id })(elements);
      return [
        ...elements.slice(0, index),
        set('content.valid', valid)(elements[index]),
        ...elements.slice(index + 1),
      ];
    }

    case EDITOR.ELEMENT.APPLY_CHANGES: {
      const { id, mergeChanges, ...changes } = action;
      const index = findIndex({ id })(elements);
      const element = elements[index];
      const content = mergeChanges
        ? merge(element.content, changes)
        : { ...element.content, ...changes };

      return [
        ...elements.slice(0, index),
        { ...element, content },
        ...elements.slice(index + 1),
      ];
    }

    case EDITOR.ELEMENT.CREATE: {
      const { position, payload: newElement } = action;
      const index = findIndex({ position })(elements);
      return sortAndUpdatePositions([
        ...elements.slice(0, index),
        newElement,
        ...elements.slice(index),
      ]);
    }

    case EDITOR.ELEMENT.REORDER: {
      const { position, newPosition } = action;
      const element = elements[position - 1];
      const newElements = update(elements, {
        $splice: [
          [position - 1, 1],
          [newPosition - 1, 0, element],
        ],
      });
      return resetPositions(newElements);
    }

    case EDITOR.ELEMENT.REPLACE: {
      const { element, id } = action;
      const index = findIndex({ id })(elements);
      return [
        ...elements.slice(0, index),
        element,
        ...elements.slice(index + 1),
      ];
    }

    case EDITOR.ELEMENT.DETACH_PARENT:
      return updateItem(elements, { id: action.id }, { parent_id: null });

    case EDITOR.ELEMENT.ASSIGN_PARENT:
      return updateItem(
        elements,
        { id: action.id },
        { parent_id: action.parentId },
      );

    case EDITOR.ELEMENT.UPDATE_COMMENTS_COUNT: {
      const newElements = updateItem(
        elements,
        { id: action.id },
        {
          comments_count: action.count,
        },
      );
      return newElements;
    }

    default:
      return elements;
  }
};

export default reduceElements;
